import React, { forwardRef } from "react";

import { combineRefs } from "@multiweb/reactUtils";
import { ForwardRefType, QAProps } from "@multiweb/types/react";
import { CaptionComponent } from "../CaptionComponent";
import { FlexDirection, Layout, SpacingSize } from "../Layout";
import { FormComponentEventHandlersProps, FormComponentProps } from "../types";
import { CheckBoxField } from "./CheckBoxField";
import { CheckBoxSwitcher } from "./CheckBoxSwitcher";
import { CaptionAlignment, CheckBoxComponentSharedProps } from "./types";

export type CheckBoxComponentProps = {
    /** Popisek zobrazený vedle checkboxu */
    label?: string;
    /** Umístění popisu */
    alignment?: CaptionAlignment;
    /** Příznak, zda chceme vynutit v checkboxu hodnotu */
    forceDefaultValue?: boolean;
    /** Defaultní hodnota checkboxu při vynucení hodnoty */
    defaultValue?: boolean;
}
    & FormComponentProps
    & CheckBoxComponentSharedProps
    & FormComponentEventHandlersProps
    & QAProps;

/** Zaškrtávací políčko */
export const CheckBoxComponent: ForwardRefType<HTMLDivElement, CheckBoxComponentProps> = forwardRef<HTMLDivElement, CheckBoxComponentProps>(({
    id,
    encrypted = false,
    hasThreeStates = false,
    invalid = false,
    label,
    onChange,
    onClick,
    onBlur,
    onFocus,
    onMouseOver,
    onMouseEnter,
    onMouseLeave,
    disabled = false,
    required = false,
    backgroundColor,
    title,
    value,
    alignment = CaptionAlignment.rightJustify,
    tabIndex,
    showFalseAsCrossed,
    qa,
    forceDefaultValue = false,
    defaultValue = true,
}, ref) => {
    const isLeftAligned = alignment === CaptionAlignment.leftJustify;
    return (
        <CheckBoxSwitcher {...{
            encrypted,
            hasThreeStates,
            disabled,
            title,
            value,
            onChange,
            onClick,
            onMouseOver,
            onMouseEnter,
            onMouseLeave,
            onBlur,
            onFocus,
            qa,
            forceDefaultValue,
            defaultValue,
        }}>
            {({ ref: switcherRef }) => {
                const joinedRefs = combineRefs<HTMLDivElement>(switcherRef, ref);
                return (
                    <Layout flexDirection={isLeftAligned ? FlexDirection.rowReverse : FlexDirection.row}>
                        <CheckBoxField
                            {...{
                                id,
                                encrypted,
                                hasThreeStates,
                                invalid,
                                disabled,
                                required,
                                backgroundColor,
                                title,
                                value,
                                tabIndex,
                                showFalseAsCrossed,
                            }}
                            ref={joinedRefs}
                        />
                        {label !== undefined && (
                            <Layout
                                spacingSizeLeft={isLeftAligned ? undefined : SpacingSize.xxs}
                                spacingSizeRight={isLeftAligned ? SpacingSize.xxs : undefined}
                            >
                                <CaptionComponent
                                    text={label}
                                    htmlFor={id}
                                    {...{ required, title }}
                                />
                            </Layout>
                        )}
                    </Layout>
                );
            }}
        </CheckBoxSwitcher>
    );
});
